<phms-case-context-record-grid
  [appTerminologyIdentity]="sectionUsage.heading"
  [heading]="sectionText.heading()"
  itemLabelSingular="offense record"
  itemLabelPlural="offense records"
  [records]="records"
  [state]="state"
  [columnDefs]="columnDefs()"
  [agGridOptions]="agGridOptions"
  [stateCopy]="{
    loadingText: 'Loading offense records...',
    emptyText: 'No offense records on file.',
    errorText: 'Offense records are temporarily unavailable.',
  }"
></phms-case-context-record-grid>
